import React from 'react'

import { Button } from '_zari/core'

const EstanteriaCard = ({ estanteria: e, onAbrir, onEditar, onDuplicar, onEliminar }) => {
  const ocupacion = e.totalCeldas > 0 ? Math.round((e.celdasOcupadas / e.totalCeldas) * 100) : 0
  const color = e.color || '#1F3A8A'

  return (
    <div className='ub-card' onClick={onAbrir}>
      <div className='ub-card-header' style={{ background: color }}>
        <div className='ub-card-codigo'>{e.codigo}</div>
        <div className='ub-card-acciones' onClick={(ev) => ev.stopPropagation()}>
          <button title='Editar' onClick={onEditar}>
            <i className='fa fa-pencil-alt' />
          </button>
          <button title='Duplicar (usar como plantilla)' onClick={onDuplicar}>
            <i className='fa fa-copy' />
          </button>
          <button title='Eliminar' onClick={onEliminar}>
            <i className='fa fa-trash' />
          </button>
        </div>
      </div>
      <div className='ub-card-body'>
        <h6 className='ub-card-nombre'>{e.nombre}</h6>
        <small className='ub-card-almacen'>{e.nombreAlmacen || '—'}</small>
        {e.descripcion && <p className='ub-card-desc'>{e.descripcion}</p>}

        <div className='ub-card-stats'>
          <div className='ub-stat'>
            <span className='ub-stat-num'>{e.filas}×{e.columnas}{e.profundidad > 1 ? `×${e.profundidad}` : ''}</span>
            <span className='ub-stat-label'>Dimensiones</span>
          </div>
          <div className='ub-stat'>
            <span className='ub-stat-num'>{e.totalCeldas}</span>
            <span className='ub-stat-label'>Celdas</span>
          </div>
          <div className='ub-stat'>
            <span className='ub-stat-num' style={{ color: '#28a745' }}>{e.celdasOcupadas}</span>
            <span className='ub-stat-label'>Ocupadas</span>
          </div>
        </div>

        <div className='ub-progress'>
          <div className='ub-progress-bar' style={{ width: `${ocupacion}%`, background: color }} />
          <span className='ub-progress-text'>{ocupacion}%</span>
        </div>

        <Button block size='sm' className='mt-2' style={{ background: color, borderColor: color, color: 'white' }}>
          <i className='fa fa-th mr-1' /> Ver matriz
        </Button>
      </div>
    </div>
  )
}

export default EstanteriaCard
